export default __webpack_public_path__ + "static/media/Experience Selector.c5cf5703.svg";